export const STATUS_OPTIONS = [
  { value: 'new', label: 'New', color: 'info' },
  { value: 'in_review', label: 'In Review', color: 'warning' },
  { value: 'planned', label: 'Planned', color: 'secondary' },
  { value: 'for_testing', label: 'For Testing', color: 'primary' },
  { value: 'needs_rework', label: 'Needs Rework', color: 'error' },
  { value: 'resolved', label: 'Resolved', color: 'success' },
];

export const CATEGORY_OPTIONS = [
  { value: 'improvement', label: 'Improvement' },
  { value: 'recommendation', label: 'Recommendation' },
  { value: 'issue', label: 'Issue' },
  { value: 'note', label: 'Note' },
  { value: 'sd_card_request', label: 'SD Card Request' },
  { value: 'rbpi_request', label: 'RBPI Request' },
  { value: 'knowledge_base', label: 'Knowledge Base' },
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low', color: 'default' },
  { value: 'normal', label: 'Normal', color: 'info' },
  { value: 'high', label: 'High', color: 'warning' },
  { value: 'critical', label: 'Critical', color: 'error' },
];

export const WORK_TYPE_OPTIONS = [
  { value: 'development', label: 'Development', color: 'primary' },
  { value: 'operations', label: 'Operations', color: 'warning' },
  { value: 'qa', label: 'QA / Testing', color: 'success' },
  { value: 'discussion', label: 'Discussion', color: 'default' },
];

export const TARGET_TYPE_OPTIONS = [
  { value: 'general', label: 'General', color: 'default' },
  { value: 'device', label: 'Device', color: 'info' },
];

export const APPROVAL_STATUS_OPTIONS = [
  { value: 'not_required', label: 'No Approval', color: 'default' },
  { value: 'waiting_for_approval', label: 'Waiting for Approval', color: 'warning' },
  { value: 'approved', label: 'Approved', color: 'success' },
];

export const APPROVAL_FILTER_OPTIONS = [
  { value: 'all', label: 'All approval states' },
  ...APPROVAL_STATUS_OPTIONS,
];

export const RECURRENCE_OPTIONS = [
  { value: 'off', label: 'No repeat' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const UPDATE_EVENT_FILTER_OPTIONS = [
  { value: 'all', label: 'All update types' },
  { value: 'comment', label: 'Comments' },
  { value: 'status_change', label: 'Status changes' },
  { value: 'other', label: 'Other updates' },
];

export const EMPTY_THREAD_DRAFT = Object.freeze({
  title: '',
  body: '',
  category: 'improvement',
  workType: 'development',
  targetType: 'general',
  priority: 'normal',
  recurrenceCadence: 'off',
  expectedExecutionTime: '',
  expectedExecutionHours: '',
  actualExecutionHours: '',
  expectedExecutionDate: '',
  requestedQuantity: '',
  deliveryAddress: '',
  testMode: false,
  extraParticipantsText: '',
  notifyCreatorOnOwnUpdates: false,
});

export const KNOWLEDGE_BASE_RESOURCES = Object.freeze([
  { label: 'Instructions', href: '/instructionsNew' },
  { label: 'Change log', href: '/change-log' },
  { label: 'Executive Summary', href: '/executive-summary' },
]);

export const statusLabelMap = STATUS_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const categoryLabelMap = CATEGORY_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const APPROVAL_REQUEST_CATEGORIES = new Set(['sd_card_request', 'rbpi_request']);

export const isApprovalRequestCategory = (category = '') =>
  APPROVAL_REQUEST_CATEGORIES.has(String(category || '').trim().toLowerCase());

export const getApprovalRequestLabel = (category = '') =>
  String(category || '').trim().toLowerCase() === 'rbpi_request'
    ? 'RBPI request'
    : 'SD card request';

export const workTypeLabelMap = WORK_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const targetTypeLabelMap = TARGET_TYPE_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const priorityLabelMap = PRIORITY_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const approvalLabelMap = APPROVAL_STATUS_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export const getDefaultWorkTypeForCategory = (category = '') => {
  switch (category) {
    case 'sd_card_request':
    case 'rbpi_request':
      return 'operations';
    case 'knowledge_base':
    case 'note':
      return 'discussion';
    default:
      return 'development';
  }
};
